export const viewsEn = {
  Home: {
    providers: 'Providers',
  },
  AllGames: {
    title: 'Games',
  },
  Provider: {},
}